import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default class TagsRelatedList extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        linkTemplate: PropTypes.string,
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                slug: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired
            })
        )
    };
    static defaultProps = {
        title: '',
        linkTemplate: '/image-photo/%slug%',
        tags: []
    }

    constructor(props) {
        super(props);
    }

    parseTemplate = slug => {
        return encodeURI(this.props.linkTemplate.replace('%slug%', slug));
    }

    render() {
        const { title, tags } = this.props;

        //Don't render if there is no tags 
        if (!tags || !tags.length) return null;

        return (
            <div className="component-tags-related-list">
                {title ? <h2 className="title">{title}</h2> : null}
                <div className="list">
                    {
                        tags.map((tag, index) => {
                            return tag.slug ? <Link className="link" to={this.parseTemplate(tag.slug)} key={index}>{tag.name}</Link> : null;
                        })
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/tags/RelatedList/index.js